import http from '../utils/http'
import api from '.'

export function Getlist(data) {
    return http.get(api.part.get, data)
}

